import { useTranslation } from "react-i18next";

import {
  Box,
  Typography,
  FormControlLabel,
  Switch,
  Stack,
} from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";

import CustomSelect from "../../Components/Select";
import { langOptions } from "../../Components/LangSwitcher/LangSwitcher";

export default function NotificationSettings({
  formData,
  emailEnabled,
  smsEnabled,
  pushEnabled,
  setEmailEnabled,
  setSmsEnabled,
  setPushEnabled,
  handleSelectChange,
}) {
  const { t } = useTranslation();

  // Custom switch styling
  const switchProps = {
    sx: {
      "& .MuiSwitch-switchBase.Mui-checked": {
        color: "#009a80",
      },
      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#009a80",
      },
    },
  };

  return (
    <Box px={2} py={3}>
      <Typography variant="subtitle1" fontWeight="bold" mb={2}>
        {t("userProfile.section_notifications_header")}
      </Typography>

      <Stack spacing={2} width={250} marginInline="auto" mb={4}>
        <FormControlLabel
          control={
            <Switch
              checked={emailEnabled}
              onChange={setEmailEnabled}
              {...switchProps}
            />
          }
          label={
            <Box display="flex" alignItems="center" gap={1}>
              <EmailOutlinedIcon />
              <Typography>
                {t("userProfile.notification_type_email")}
              </Typography>
            </Box>
          }
          labelPlacement="start"
          sx={{ justifyContent: "space-between", m: 0 }}
        />

        <FormControlLabel
          control={
            <Switch
              checked={smsEnabled}
              onChange={setSmsEnabled}
              {...switchProps}
            />
          }
          label={
            <Box display="flex" alignItems="center" gap={1}>
              <SmsOutlinedIcon />
              <Typography>{t("userProfile.notification_type_sms")}</Typography>
            </Box>
          }
          labelPlacement="start"
          sx={{ justifyContent: "space-between", m: 0 }}
        />

        <FormControlLabel
          control={
            <Switch
              checked={pushEnabled}
              onChange={setPushEnabled}
              {...switchProps}
            />
          }
          label={
            <Box display="flex" alignItems="center" gap={1}>
              <NotificationsNoneOutlinedIcon />
              <Typography>{t("userProfile.notification_type_push")}</Typography>
            </Box>
          }
          labelPlacement="start"
          sx={{ justifyContent: "space-between", m: 0 }}
        />
      </Stack>

      <CustomSelect
        options={langOptions}
        value={formData.notificationLang || ""}
        name="notificationLang"
        onChange={handleSelectChange}
        label={t("userProfile.select_notifications_lang_label")}
      />
    </Box>
  );
}
